import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {HostActivityApi} from '@domain/activity/host-activity.api';
import {HostResolver} from '@domain/host/host.resolver';


export class HostActivityResolver {

  public static readonly allActivities: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const api = inject(HostActivityApi);
    const hostId = HostResolver.resolveHostId(route)!;
    return api.getAllActivities(hostId);
  };

  public static readonly publicActivities: ResolveFn<ActivityDTO[] | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const api = inject(HostActivityApi);
    const hostId = HostResolver.resolveHostId(route)!;
    return api.getPublishedActivities(hostId);
  };

}
